import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
export default {
  name: 'NiotaClassicDevicetypesSyncronizeHealthStatesDialog',
  props: {
    dialogSyncHealthStateOpen: {
      type: Boolean,
      default: false
    },
    tenantId: {
      type: Number,
      default: null
    },
    linkedVirtualDevicesIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      jobTitle: ''
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    getTotalDevicesNumber() {
      return this.linkedVirtualDevicesIds.length;
    },
    rules() {
      return [v => !!v || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.required'), v => (v.trim() || '').length <= 50 || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.max', {
        n: 50
      }), v => (v.trim() || '').length >= 5 || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.min', {
        n: 5
      })];
    },
    isApplyBtnInDialogDisabled() {
      return this.jobTitle.length < 5 || this.jobTitle.length > 50;
    }
  },
  methods: {
    closeSyncHealthStateDialog() {
      this.jobTitle = '';
      this.$emit('close');
    },
    syncHealthStates() {
      const data = {
        entities: this.linkedVirtualDevicesIds,
        tenantId: this.tenantId,
        title: this.jobTitle,
        executions: {
          syncHealthConfiguration: true
        }
      };
      ApiService.createBackgroundRunnerBulkEdit(data).then(() => {
        this.closeSyncHealthStateDialog();
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.bulkEditSuccess', {
          n: this.getTotalDevicesNumber
        }), 'success');
      }).catch(error => {
        this.closeSyncHealthStateDialog();
        this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
      });
    }
  }
};